import React, { useEffect, useRef, useState } from 'react'

import { AddNode, ClearFilter, DeleteIcon, FilterClearIcon, FilterIcon, InfoIcon1, LeftArrowWhite, RightArrow, SaveFilter, SearchIcon, SearchIconWhite } from '../../../../assets/images'
import { Dropdown, Modal, OverlayTrigger, Pagination, Tab, Tabs, Tooltip } from 'react-bootstrap'
import { MultiSelect } from 'react-multi-select-component'
import { DatePicker } from 'rsuite';
import FilterToolDDLTemp from '../../../AlertViewNew/FilterToolDDLTemp';
import { useCustomer } from '../../../../CustomHooks/useCustomer';
import { useSite } from '../../../../CustomHooks/useSite';
import { addStorageForm, deleteStorageDetails, getFilterRecording, getInterfaceName, getInterfaceTypeBySite, getRecordingTypeList, getSiteTypeList, getStorageList, getStorageTableFormDetails, getStorageType, updateStorageForm, updateStorageTableForm } from '../../../../services/configurationServices';
import StorageConfigItem from './StorageConfigItem';
import { SuccessToast } from '../../../../CustomHooks/SuccessToast';
import { ErrorToast } from '../../../../CustomHooks/ErrorToast';
import Swal from 'sweetalert2';
import { useDataAccessPagination } from '../../../../CustomHooks/useDataAccessPagination';
import { WarningToast } from '../../../../CustomHooks/WarningToast';
import RestoreIcon from '@mui/icons-material/Restore';

const options = [
    { label: "Option 1", value: "option 1" },
    { label: "Option 2", value: "Option 2" },
];

const StorageConfig = ({ isDarkTheme, storageForm, setStorageForm, item, DeviceRecordingConfigID, resetServer, recordingServerType, selectedRecordingServerType, RecordingServerTypeID }) => {
    //const { DeviceName, DeviceID, RTSPCameraUrl, EnableRecording, Status, InPutURL, RecordingRetentionPeriod, RecordingLength, IsTranscodingEnable, TranscodingConfig, FPS, RecordingTypeID, ScheduleId, FromDateTime, ToDateTime }
    const [selected, setSelected] = useState([]);
    const [show, setShow] = useState(false);
    const [selectedOption, setSelectedOption] = useState("");
    const [isFormEdit, setIsFormEdit] = useState(false)
    const [storageName, setStorageName] = useState('')
    const [storageNameError, setStorageNameError] = useState("")
    const [storageType, setStorageType] = useState([])
    const [selectedStorageTypeError, setSelectedStorageTypeError] = useState("")
    const [storeRecordingError, setStoreRecordingError] = useState("")
    const [primaryStoragePath, setPrimaryStoragePath] = useState("");
    const [primaryStoragePathError, setPrimaryStoragePathError] = useState("");
    const [primaryStorageAccessURL, setPrimaryStorageAccessURL] = useState("");
    const [primaryStorageAccessURLError, setPrimaryStorageAccessURLError] = useState("");
    const [searchStorageName, setSearchStorageName] = useState("");
    const [storageList, setStorageList] = useState(null);
    const [masterStorageList, setMasterStorageList] = useState(null)
    const [selectedStorage, setSelectedStorage] = useState(null);
    const [activeTabKey, setActiveTabKey] = useState('StorageForm_Details');
    const [selectedFilterName, setSelectedFilterName] = useState("")
    const [filterList, setFilterList] = useState([]);
    const [selectedFilter, setSelectedFilter] = useState(0);
    const [customerSelected, setCustomerSelected] = useState([]);
    const [siteSelected, setSiteSelected] = useState([]);
    const [disableSaveBtn, setDisableSaveBtn] = useState(false)
    //const [filterApplied, setFilterApplied] = useState(false);
    const [interfaceSubTypeOptions, setInterfaceSubTypeOptions] = useState([])
    const [interfaceSubTypeSelected, setInterfaceSubTypeSelected] = useState([])
    const [interafaceNameOptions, setInterafaceNameOptions] = useState([])
    const [interafaceNameSelected, setInterafaceNameSelected] = useState([])
    const [customerString, setCustomerString] = useState("")
    const [siteString, setSiteString] = useState("")
    const [interfaceSubTypeString, setInterfaceSubTypeString] = useState("")
    const [interfaceNameString, setInterfaceNameString] = useState("")
    const [selectedStorageType, setSelectedStorageType] = useState(0)
    const { customerOptions } = useCustomer()
    const { siteOptions, getSite, setSiteOptions } = useSite();
    const [timer, setTimer] = useState(null);
    const [
        nextClick,
        prevClick,
        pageCounter,
        currentPageNo,
        limit,
        totalPages,
        setCurrentPageNo,
        setTotalPages,
        maxPageAllowed,
        setPageCounter,
    ] = useDataAccessPagination(10, 1, 10, 1);
    // [nextClickOne, prevClickOne, pageCounterOne, currentPageNoOne, limitOne, totalPagesOne, setCurrentPageNoOne, setTotalPagesOne, maxPageAllowedOne, setPageCounterOne] = useDataAccessPagination(10, 1, 10, 1);
    const [filterAppliedStatus, setFilterAppliedStatus] = useState(false)
    const [totalString, setTotalString] = useState(
        "deviceId:;deviceName:;recordingStatus:;inputSourceUrl:;encodingStatus:;recordingType:"
    );
    const [showButton, setShowButton] = useState(false)
    const [buttonDisable, setButtonDisable] = useState(false)
    const [transcodingList, setTranscodingList] = useState([])
    const [recordingTypeList, setRecordingTypeList] = useState([])
    const [deviceIdSearch, setDeviceIdSearch] = useState("")
    const [inputUrlSearch, setInputUrlSearch] = useState("")
    const [recordingTypeSearch, setRecordingTypeSearch] = useState("")
    const [deviceNameSearch, setDeviceNameSearch] = useState("")
    const [selectEnableRecording, setSelectEnableRecording] = useState("")
    const [selectDisableRecording, setSelectDisableRecording] = useState("")
    const [selectEncoding, setSelectEncoding] = useState("")
    const [count, setCount] = useState(0)
    const [totalDevices, setTotalDevices] = useState(0);
    const tableRef = useRef(null);
    const [selectedRecordingType, setSelectedRecordingType] = useState("")
    const [selectedRecordTypeError, setSelectedRecordTypeError] = useState("")
    const [fromTimeModal, setFromTimeModal] = useState(null)
    const [toTimeModal, setToTimeModal] = useState(null)
    const [fromTimeModalError, setFromTimeModalError] = useState("")
    const [toTimeModalError, setToTimeModalError] = useState("")
    const [storeRecording, setStoreRecording] = useState(null)
    const [fromTimeError, setFromTimeError] = useState("")
    const [toTimeError, setToTimeError] = useState("")
    // useEffect(() => {
    //     let cOne = currentPageNo;
    //     setCurrentPageNo(cOne);
    //     setPageCounter(cOne);
    //     setTotalPages(parseInt(40));
    // }, []);
    console.log("AKSHATA", recordingServerType)
    useEffect(() => {
        if (firstRender.current) {
            clearTimeout(timer);
            const newTimer = setTimeout(() => {
                searchListDetails();
            }, 500);
            setTimer(newTimer);
        }
        firstRender.current = true;
    }, [
        deviceIdSearch,
        deviceNameSearch,
        selectEnableRecording,
        inputUrlSearch,
        selectEncoding,
        recordingTypeSearch

    ]);

    useEffect(() => {
        clearFilterList()
    }, [selectedStorage])
    useEffect(() => {
        console.log("UseEffect Called One")
        getStorageFormData(customerString, siteString, interfaceSubTypeString, interfaceNameString, currentPageNo, totalString, filterAppliedStatus, selectedStorage?.RecordingStoragePathID)
    }, [currentPageNo, count])

    useEffect(() => {
        getStorageListForm(item.RecordingStorageID)
    }, [])
    useEffect(() => {
        getTranscodingConfig()
    }, [])

    useEffect(() => {
        console.log("USEEFFECT", item)
        console.log("USEEFFECT", recordingServerType)
        let serverTypeValue = recordingServerType?.find(i => i.RecordingServerTypeID == item.RecordingServerTypeID)
        console.log("serverTypeValue", serverTypeValue)
        getRecordingType(serverTypeValue?.RecordingServerType)
    }, [item, recordingServerType])

    const firstRender = useRef(false);
    console.log("selectedStorageType", selectedRecordingServerType)
    useEffect(() => {
        if (customerSelected.length > 0) {
            // Call API for getting sitedata.
            let customerIds = customerSelected.map((item) => item.value).join(',');
            getSite(customerIds)
            setDisableSaveBtn(true)
        } else {
            setSiteOptions([]);
            setSiteSelected([]);
            setDisableSaveBtn(false)
        }
    }, [customerSelected])


    useEffect(() => {
        if (siteSelected.length > 0) {
            let siteIds = siteSelected.map((item) => item.value).join(',');
            getInterfaceSubTypeBySiteBasis(siteIds)
            setDisableSaveBtn(true)
        } else {
            setInterfaceSubTypeOptions([]);
            setInterfaceSubTypeSelected([])
            setDisableSaveBtn(false)
        }
    }, [siteSelected])

    useEffect(() => {
        if (customerSelected.length == 0 && siteSelected.length == 0 && interafaceNameSelected.length == 0 && interfaceSubTypeSelected.length == 0 && filterAppliedStatus) {
            setFilterAppliedStatus(false);
            clearFilterList()
            console.log("UseEffect Called Two")
            getStorageFormData("", "", "", "", 1, "", false, selectedStorage?.RecordingStoragePathID)
        }
    }, [customerSelected, siteSelected, interafaceNameSelected, interfaceSubTypeSelected]);

    useEffect(() => {
        if (interfaceSubTypeSelected.length > 0) {
            let interfaceSubTypeIds = interfaceSubTypeSelected.map((item) => item.value).join(',');
            let siteIds = siteSelected.map((item) => item.value).join(',');
            getInterfaceNameBasis(interfaceSubTypeIds, siteIds)
            setDisableSaveBtn(true)
        } else {
            setInterafaceNameOptions([]);
            setInterafaceNameSelected([])
            setDisableSaveBtn(false)
        }
    }, [interfaceSubTypeSelected]);

    useEffect(() => {
        handleStorageTypeChange()
    }, [])

    useEffect(() => {
        const adjustColumnWidths = () => {
            if (!tableRef.current) return;

            const headers = tableRef.current.querySelectorAll('thead tr:first-child th');
            const rows = tableRef.current.querySelectorAll('tbody tr');

            headers.forEach((header, columnIndex) => {
                let maxWidth = header.offsetWidth;

                rows.forEach((row) => {
                    const cell = row.querySelector(`td:nth-child(${columnIndex + 1})`);
                    if (cell) {
                        maxWidth = Math.max(maxWidth, cell.offsetWidth);
                    }
                });

                header.style.width = `${maxWidth}px`;
                rows.forEach((row) => {
                    const cell = row.querySelector(`td:nth-child(${columnIndex + 1})`);
                    if (cell) {
                        cell.style.width = `${maxWidth}px`;
                    }
                });
                const searchInputHeader = tableRef.current.querySelector(`thead tr:nth-child(2) th:nth-child(${columnIndex + 1})`);
                if (searchInputHeader) {
                    searchInputHeader.style.width = `${maxWidth}px`;
                }
            });
        };

        adjustColumnWidths();
    }, []);

    const clearStorageForm = () => {
        setStorageName('')
        setStorageNameError('')
        setPrimaryStoragePath('')
        setPrimaryStoragePathError('')
        setPrimaryStorageAccessURL('')
        setPrimaryStorageAccessURLError('')
        setSelectedStorageType('')
        setSelectedStorageTypeError('')
        setIsFormEdit(false)
        setSelectedStorage(null)
        setStoreRecordingError('')
        setStoreRecording('')
        setSelectedRecordTypeError('')
        setSelectedRecordingType('')
        setShowButton(false)
        setToTimeError('')
        setFromTimeError('')
        setFromTimeModal(null)
        setToTimeModal(null)
        setFromTimeModalError('')
        setToTimeModalError('')
    }
    //   useEffect(() => {
    //     if (selectedFilter != 0) {
    //       let selected = filterList.find((item) => item.FilterId == selectedFilter);
    //       if (selected != null) {
    //         extractIds(selected.FilterValues);

    //       }
    //     }
    //   }, [selectedFilter]);
    const getTranscodingConfig = () => {
        try {
            let obj = {
                type: "TranscodingTypeDetails",
            };
            getSiteTypeList(obj).then((resp) => {
                if (resp != undefined) {
                    if (resp.Status == "success") {
                        setTranscodingList(resp.Data);
                    } else {
                        setTranscodingList([]);
                    }
                }
            });
        } catch (error) {
            console.error(error);
        }
    }
    const getRecordingType = (ServerType) => {
        getRecordingTypeList(ServerType).then((resp) => {
            if (resp.Status == "success") {
                setRecordingTypeList(resp.Data);
                console.log("resp.Data", resp.Data)
            } else {
                setRecordingTypeList([]);
            }
        }).catch(err => console.log(err))
    }
    console.log("selectedRecordingType291", selectedRecordingType)
    const onSaveStoargeForm = async () => {
        let isValidate = false


        if (storageName == "") {
            setStorageNameError("Please enter storage name!")
            isValidate = true;
        }
        if (primaryStoragePath == "") {
            setPrimaryStoragePathError("Please enter primary server path")
            isValidate = true;
        }
        if (primaryStorageAccessURL == "") {
            setPrimaryStorageAccessURLError("Please enter primary server access url")
            isValidate = true;
        }
        if (selectedStorageType == "" || selectedStorageType == 0) {
            setSelectedStorageTypeError("Please select storage type")
            isValidate = true;
        }
        if (selectedRecordingType == 0 || selectedRecordingType == null || selectedRecordingType == "") {
            setSelectedRecordTypeError("Please select recording type")
            isValidate = true;
        }
        if (storeRecording == 0 || storeRecording == null || storeRecording == "") {
            setStoreRecordingError("Please select the number of days of recording.")
            isValidate = true;
        } else if (storeRecording < 2) {
            ErrorToast("Please select at least 2 days for recording.");
            isValidate = true;
        }
        console.log("recordingTypeList",recordingTypeList)
        let modalTimeBased = recordingTypeList?.find(i => i.RecordingType == "Time Based")
        console.log("recordingTypeList", modalTimeBased)
        console.log("recordingTypeList", fromTimeModal)
        console.log("recordingTypeList", toTimeModal)
        console.log("recordingTypeList", selectedRecordingType)
        if (modalTimeBased?.RecordingTypeId == selectedRecordingType){
            console.log("recordingTypeList inside If")
             if (fromTimeModal == "" || fromTimeModal == 0 || fromTimeModal == null) {
                setFromTimeError("Please enter a fromtime")
                isValidate = true;
            }
            if(toTimeModal == "" || toTimeModal == 0 || toTimeModal == null){
                setToTimeError("Please enter a totime")
                isValidate = true;
            }
        }
        
        let modalscheduleBase = recordingTypeList?.find(i => i.RecordingType == "Scheduled")
        if(modalscheduleBase?.RecordingTypeId == selectedRecordingType){
            if (fromTimeModal == "" || fromTimeModal == 0 || fromTimeModal == null) {
                setFromTimeError("Please enter a fromtime")
                isValidate = true;
            }
        }

        if (isValidate) {
            return;
        }
        console.log("selectedStorage", selectedStorage)
        console.log("item324", item)
        if (selectedStorage == null) {
            console.log("selectedStorage", selectedStorage)
            let addStoargeObj = {
                RecordingStorageID: item?.RecordingStorageID,
                Name: storageName?.toString().trim(),
                StorageTypeID: selectedStorageType,
                PrimaryRecordingStoragePath: primaryStoragePath,
                PrimaryAccessURL: primaryStorageAccessURL,
                RecordingRetentionPeriod: storeRecording,
                RecordingTypeID: selectedRecordingType,
                FromDateTime: fromTimeModal,
                ToDateTime: toTimeModal
            }
            addStorageForm(addStoargeObj).then((resp) => {
                if (resp.Status == "success") {
                    getStorageListForm(item?.RecordingStorageID)
                    SuccessToast(resp.Message)
                    clearStorageForm()
                    
                    //setSelectedStorage(null)
                } else {
                    ErrorToast(resp.Message)
                }
            })
        }

        else {
            let updateStorageObj = {
                RecordingStoragePathID: selectedStorage.RecordingStoragePathID?.toString(),
                RecordingStorageID: item?.RecordingStorageID,
                Name: storageName,
                StorageTypeID: selectedStorageType,
                PrimaryRecordingStoragePath: primaryStoragePath,
                PrimaryAccessURL: primaryStorageAccessURL,
                RecordingRetentionPeriod: storeRecording,
                RecordingTypeID: selectedRecordingType,
                ScheduleId: selectedStorage?.ScheduleId,
                FromDateTime: fromTimeModal,
                ToDateTime: toTimeModal
            }
            updateStorageForm(updateStorageObj).then((resp) => {
                if (resp.Status == "success") {
                    let updateStorageTableObj = {
                        RecordingTypeID: selectedRecordingType,
                        ScheduleId: selectedStorage?.ScheduleId,
                        FromDateTime: fromTimeModal,
                        ToDateTime: toTimeModal,
                        RecordingRetentionPeriod: storeRecording,
                        RecordingStoragePathID: selectedStorage.RecordingStoragePathID?.toString(),
                        updateFlag: 1
                    }
                    updateStorageTableForm(updateStorageTableObj).then((res) => {
                        console.log("res", res)
                    })
                    getStorageListForm(item?.RecordingStorageID)
                    setIsFormEdit(false)
                    clearStorageForm()
                    SuccessToast(resp.Message)
                    //setSelectedStorage(null)

                } else {
                    ErrorToast(resp.Message)
                }
            })

        }
    }

    const handleRecordingForm = () => {
        setStorageForm(false)
        resetServer();
    }

    // const getFilterBaseList = async (clientIds, siteIds, interfaceSubTypeIds, interfaceIds)=>{
    //     getFilterRecording(clientIds, siteIds, interfaceSubTypeIds, interfaceIds).then((resp) => {
    //         if (resp.Status == "success" && resp.Data != null){
    //             setFilterList(resp.Data)
    //         }else{
    //             setFilterList([])
    //         }
    //     }).catch(err => console.log(err))
    // }
    const getStorageListForm = (RecordingStorageID) => {
        getStorageList(RecordingStorageID).then((resp) => {
            if (resp.Status == "success" && resp.Data != null) {
                setStorageList(resp.Data);
                setMasterStorageList(resp.Data);
            } else {
                setStorageList(null);
                setMasterStorageList(null);
            }
        }).catch(err => console.log(err))
    }
    const onSearchChange = (e) => {
        //     setRecordingSearch(e.target.value);
        //     let tempArr = masterStorageList.filter((x) =>
        //       x.RecordingStorageName.toLowerCase().includes(
        //         e.target.value.toLowerCase()
        //       )
        //     );
        //     setRecordingList(tempArr);
        //   };
    }

    const searchStorageList = (val) => {
        setSearchStorageName(val);
        console.log("tempArr", masterStorageList)
        let tempArr = masterStorageList.filter((x) =>
            x.Name.toLowerCase().includes(
                val.toLowerCase()
            )
        );
        console.log("tempArr", tempArr)
        setStorageList(tempArr);
        console.log("tempArr", tempArr)
    };


    const handleChange = (event) => {
        const value = event.target.value;
        setSelectedOption(value);

        if (value === "Schedule") {
            setShow(true);
        }
    };

    const hideModelUI = () => {
        setShow(false);
    }
    console.log("recordingTypeList", recordingTypeList)
    const onSetModal = () => {
        let isValidate = false
        console.log("isValidate", fromTimeModal)
        console.log("isValidate", toTimeModal)
        let timeBase = recordingTypeList?.find(i => i.RecordingType == "Time Based")
        if (timeBase?.RecordingType == "Time Based") {
            if (fromTimeModal == "" || fromTimeModal == 0 || fromTimeModal == null) {
                setFromTimeModalError("please enter a  FromTime")
                isValidate = true;
            }
            else if (toTimeModal == "" || toTimeModal == 0 || toTimeModal == null) {
                setToTimeModalError("please enter a Totime")
                isValidate = true;
            }
        }

        let scheduleBase = recordingTypeList?.find(i => i.RecordingType == "Scheduled")
        console.log("scheduleBase", scheduleBase)
        if (scheduleBase?.RecordingType == "Scheduled") {
            if (fromTimeModal == "" || fromTimeModal == 0 || fromTimeModal == null) {
                setFromTimeModalError("please enter a  FromTime")
                isValidate = true;
            }
        }

        console.log("isValidate", isValidate)
        if (isValidate) {


            return;
        } else {
            hideModel()
        }
    }
    const hideModel = () => {
        setShow(false);
    }

    const getInterfaceSubTypeBySiteBasis = (siteIds) => {
        getInterfaceTypeBySite(siteIds).then((resp) => {
            if (resp.Status == "success" && resp.Data != null) {
                let arr = resp.Data.map((item) => ({
                    value: item.InterfacesubtypeId,
                    label: item.Interfacesubtypename
                }))
                setInterfaceSubTypeOptions(arr);
            } else {
                setInterfaceSubTypeOptions(null);
            }
        }).catch(err => console.log(err))
    }
    const getInterfaceNameBasis = (interfaceSubTypeIds, siteIds) => {
        getInterfaceName(interfaceSubTypeIds, siteIds).then((resp) => {
            if (resp.Status == "success" && resp.Data != null) {
                let arr = resp.Data.map((item) => ({
                    value: item.InterfaceId,
                    label: item.InterfaceName
                }))
                setInterafaceNameOptions(arr);
            } else {
                setInterafaceNameOptions(null);
            }
        }).catch(err => console.log(err))
    }
    const applyFilterOnClick = () => {
        setFilterAppliedStatus(true)
        //setFilterApplied(false);
        let customerIds = customerSelected.map((i) => i.value).join(",");
        setCustomerString(customerIds);
        let siteIds = siteSelected.map((i) => i.value).join(",");
        setSiteString(siteIds)
        let interfaceSubTypeIds = interfaceSubTypeSelected.map((i) => i.value).join(",");
        setInterfaceSubTypeString(interfaceSubTypeIds)
        let interfaceNameIds = interafaceNameSelected.map((i) => i.value).join(",");
        setInterfaceNameString(interfaceNameIds)
        //setFilterApplied(true);
        // let end;
        // let endCurrDate;
        // if (activeTab == YESTERDAY || activeTab == NONE) {
        //   endCurrDate = endDate;
        // } else {
        //   end = getSecondDate();
        //   endCurrDate = ConvertDate(end);
        // }
        //getFilterBaseList(customerIds, siteIds, interfaceSubTypeIds, interfaceNameIds);
        getStorageFormData(customerIds, siteIds, interfaceSubTypeIds, interfaceNameIds, currentPageNo, totalString, true, selectedStorage?.RecordingStoragePathID, true)

        //SuccessToast("filter applied Successfully")
    }
    const filterToolDDLProps = {
        visibleSavedfilter: false,
        savedFilterProps: {
            labelledBy: "Saved Filter",
            options: options,
            value: [],
            // onChange: (value) => setSelected(value),
            valueRenderer: null
        },
        filterList: [
            {
                labelledBy: "Customer",
                options: customerOptions,
                value: customerSelected,
                onChange: (value) => setCustomerSelected(value),
                // onChange: (value) => dispatch(cameraActions?.setCustomerSelected(value)),
                valueRenderer: null,
                className: customerSelected.length > 0 ? "dropdownSelectionContainer multi-select" : "multi-select",
            },
            {
                labelledBy: "Site",
                options: siteOptions,
                value: siteSelected,
                onChange: (value) => setSiteSelected(value),
                valueRenderer: null,
                className: siteSelected.length > 0 ? "dropdownSelectionContainer multi-select" : "multi-select",
            },
            {
                labelledBy: "Interface Sub Type",
                options: interfaceSubTypeOptions,
                value: interfaceSubTypeSelected,
                onChange: (value) => setInterfaceSubTypeSelected(value),
                valueRenderer: null,
                className: interfaceSubTypeSelected.length > 0 ? "dropdownSelectionContainer multi-select" : "multi-select",
            },
            {
                labelledBy: "Interface Name",
                options: interafaceNameOptions,
                value: interafaceNameSelected,
                onChange: (value) => setInterafaceNameSelected(value),
                valueRenderer: null,
                className: interafaceNameSelected.length > 0 ? "dropdownSelectionContainer multi-select" : "multi-select",
            },
        ]
    }

    const clearFilterList = () => {
        setInterfaceSubTypeSelected([]);
        setInterafaceNameSelected([]);
        setSiteSelected([]);
        setCustomerSelected([]);
        clearSelectedFilter();
        setFilterAppliedStatus(false)
    }
    const clearSelectedFilter = () => {
        setCustomerString("");
        setSiteString("");
        setInterfaceSubTypeString("");
        setInterfaceNameString("");
        setSelectedFilterName("")
        setSelectedFilter(0)
        // statusRef.current = "1,2"
        // let end;
        // let endCurrDate;
        // if (activeTab == YESTERDAY || activeTab == NONE) {
        //   endCurrDate = endDate;
        // } else {
        //   end = getSecondDate();
        //   endCurrDate = ConvertDate(end);
        // }
        getStorageFormData("", "", "", "", 1, "", false, selectedStorage?.RecordingStoragePathID);
    }

    const handleStorageTypeChange = () => {
        // const selectedOption = e.target.options[e.target.selectedIndex];
        // const selectedCountryValue = selectedOption.value;
        // const selectedStorageValueId = selectedOption.getAttribute('id');
        try {
            getStorageType().then((resp) => {
                if (resp != undefined) {
                    if (resp.Status == "success") {
                        setStorageType(resp.Data)
                    } else {
                        setStorageType([])
                    }
                }
            })
        } catch (error) {
            console.error(error)
        }
    }

    const deleteStorageForm = () => {
        setButtonDisable(true);
        try {
            Swal.fire({
                title: "Are you sure?",
                text: "Do you want to delete storage!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#027aaa",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, Delete it!",
            }).then((result) => {
                if (result.isConfirmed) {
                    // let obj = {
                    //     RecordingStorageID:selectedRecording.RecordingStorageID
                    // }
                    deleteStorageDetails(selectedStorage?.RecordingStoragePathID).then((res) => {
                        if (res.Status == "success") {
                            setButtonDisable(false);
                            SuccessToast(res.Message);
                            getStorageListForm(item?.RecordingStorageID);
                            //   setNotifDeleteBtnClicked(false);
                            //   setIsNotifFormEnabled(true);
                            clearStorageForm()
                            setSelectedStorage(null)
                        }
                        else if (res.Status == "failed") {
                            Swal.fire({ text: res.Message });
                            setButtonDisable(false);
                        } else {
                            Swal.fire({ text: "Something went wrong, please try again later!" })
                            setButtonDisable(false);
                        }
                    })
                        .catch((err) => console.log(err));
                } else {
                    setButtonDisable(false);
                    // setNotifDeleteBtnClicked(false);
                }
            });
        } catch (error) {
            console.log(error);
            setButtonDisable(false);
        }
    }
    const PaginationComponentOne = (currentPageNo) => {
        let numbers = [];
        if (maxPageAllowed - 2 != 0 && (currentPageNo === maxPageAllowed || currentPageNo === (maxPageAllowed - 1) || currentPageNo === (maxPageAllowed - 2))) {
            numbers.push(
                <Pagination.Item
                    key={maxPageAllowed - 2}
                    active={maxPageAllowed - 2 == currentPageNo}
                    onClick={() => setCurrentPageNo(maxPageAllowed - 2)}
                >
                    {maxPageAllowed - 2}
                </Pagination.Item>)
            numbers.push(
                <Pagination.Item
                    key={maxPageAllowed - 1}
                    active={maxPageAllowed - 1 == currentPageNo}
                    onClick={() => setCurrentPageNo(maxPageAllowed - 1)}
                >
                    {maxPageAllowed - 1}
                </Pagination.Item>)
            numbers.push(
                <Pagination.Item
                    key={maxPageAllowed}
                    active={maxPageAllowed == currentPageNo}
                    onClick={() => setCurrentPageNo(maxPageAllowed)}
                >
                    {maxPageAllowed}
                </Pagination.Item>)
        }
        else if (maxPageAllowed - 1 != 0 && (currentPageNo === maxPageAllowed || currentPageNo === (maxPageAllowed - 1))) {
            numbers.push(
                <Pagination.Item
                    key={maxPageAllowed - 1}
                    active={maxPageAllowed - 1 == currentPageNo}
                    onClick={() => setCurrentPageNo(maxPageAllowed - 1)}
                >
                    {maxPageAllowed - 1}
                </Pagination.Item>)
            numbers.push(
                <Pagination.Item
                    key={maxPageAllowed}
                    active={maxPageAllowed == currentPageNo}
                    onClick={() => setCurrentPageNo(maxPageAllowed)}
                >
                    {maxPageAllowed}
                </Pagination.Item>)
        }
        else {
            for (let i = currentPageNo; i < currentPageNo + 3; i++) {
                if (i <= maxPageAllowed) {
                    numbers.push(
                        <Pagination.Item
                            key={i}
                            active={i == currentPageNo}
                            onClick={() => setCurrentPageNo(i)}
                        >
                            {i}
                        </Pagination.Item>
                    )
                }
            }
        }
        return numbers;
    }

    const searchListDetails = (data, type) => {
        // let tempInterfaceType = interfaceTypeSearch.replace("0", "");
        // let tempCurrentStatus = currentStatusSearch.replace("0", "");
        // let tempEntityData = entityNameSearch.replace("0", "");
        // let tempDateTime = datetimeSearch;


        let obj = {
            deviceId: deviceIdSearch,
            deviceName: deviceNameSearch,
            recordingStatus: selectEnableRecording,
            inputSourceUrl: inputUrlSearch,
            encodingStatus: selectEncoding,
            recordingType: recordingTypeSearch,

        };
        let stringText = JSON.stringify(obj);
        let tempStringText = stringText.replace(/["'{}]/g, "").replace(/[,]/g, ";");
        setTotalString(tempStringText);
        getStorageFormData(customerString, siteString, interfaceSubTypeString, interfaceNameString, currentPageNo, tempStringText, filterAppliedStatus, selectedStorage?.RecordingStoragePathID);
    };

    const getStorageFormData = (customerIds, siteIds, interfaceSubTypeIds, interfaceNameIds, currentPageNo, totalString, filterAppliedStatus, RecordingStoragePathID, showToast) => {
        let loggedInUser = JSON.parse(localStorage.getItem("user"));
        let storageTableObj = {
            uniqueId: loggedInUser?.Id,
            clientIds: customerIds,
            siteIds: siteIds,
            interfaceSubTypeIds: interfaceSubTypeIds,
            interfaceIds: interfaceNameIds,
            deviceType: "Camera",
            pageNumber: currentPageNo,
            recordingConfigId: RecordingStoragePathID,
            filterApplied: filterAppliedStatus,
            searchText: totalString
        }
        getStorageTableFormDetails(storageTableObj).then((resp) => {
            if (resp.Status == "success") {
                console.log("respStatus", resp.Status)
                setFilterList(resp.Data.DeviceStatusModels)
                setTotalPages(parseInt(resp.Data.Total));
                setTotalDevices(parseInt(resp.Data.Total));
                if (showToast) {
                    SuccessToast(resp.Message)
                }
                // setCurrentPageNo(1);
                // setPageCounter(1); 
            } else {
                setFilterList([])
                setTotalPages(0);
                setTotalDevices(0);
            }
        }).catch(err => console.log(err))
    }
    const handleChangeRecordingType = (event) => {
        const value = event.target.value;
        setSelectedOption(value);
        setSelectedRecordingType(value)
        let timeBase = recordingTypeList?.find(i => i.RecordingType == "Time Based")
        let scheduleBase = recordingTypeList?.find(i => i.RecordingType == "Scheduled")
        console.log("selectedOption", timeBase)
        console.log("selectedOption", scheduleBase)
        if (value == timeBase?.RecordingTypeId || value == scheduleBase?.RecordingTypeId) {
            setShow(true);
            setShowButton(true)
        }else{
            if (selectedStorage == null){
                    setFromTimeModal(null)
                    setToTimeModal(null)
            }
            setShowButton(false)

        }
        
        console.log("selectedOption", value)
        console.log('selectedOption', selectedOption)
        //     if (selectedOption == "Time Based") {
        //     setShow(true);  
        // }
        setSelectedRecordTypeError('')
        setToTimeError('')
        setFromTimeError('')
    };
    const resetTime = () => {
        setShow(true)
    }

    console.log("item790", item)

    console.log("IssueCheck", recordingServerType)
    console.log("IssueCheck", RecordingServerTypeID)
    console.log("IssueCheck", recordingTypeList)

    return (
        <div className='SiteMainContainer UserHgtContainer'>
            <div className="SiteMainHeightDiv">
                <div className='SiteLeftContainer AutoHgtSiteScrollbar'>
                    <div className='ZoneHeaderDiv'>
                        <button className="addCustomer" onClick={handleRecordingForm}>
                            <span className="ViewUpdate">
                                <img src={LeftArrowWhite} alt="add plus icon" />
                            </span>
                        </button>
                        <p>{item?.RecordingStorageName}</p>
                        {/* <p>Selected recording system name</p> */}
                    </div>
                    <div className="m-2 HeaderSiteList">
                        <input
                            id="Search_txt_site"
                            className="SearchViewInput1"
                            type="text"
                            placeholder="Search Stoarge Name"
                            value={searchStorageName}
                            onChange={(e) => { searchStorageList(e.target.value) }}
                        />
                        <div className="SearchTextDivConfigTool">
                            {
                                isDarkTheme ?
                                    <img
                                        className="EyeIcon"
                                        src={SearchIcon}
                                        alt="search icon"
                                    /> :
                                    <img
                                        className="EyeIcon"
                                        src={SearchIconWhite}
                                        alt="search icon" height="15"
                                    />
                            }
                        </div>
                    </div>
                    <div className="StepperSiteList" id="siteListDiv" >
                        {
                            storageList && (
                                storageList.length > 0
                                    ?
                                    storageList?.map((item) => (
                                        <div key={item?.RecordingStoragePathID}
                                            className={selectedStorage?.RecordingStoragePathID == item?.RecordingStoragePathID ? `OneList SelectedList` : `OneList`}
                                        >
                                            <div className="ListSiteWithZone"
                                                onClick={(e) => {
                                                    setPrimaryStorageAccessURL(item?.PrimaryAccessURL)
                                                    setPrimaryStoragePath(item?.PrimaryRecordingStoragePath)
                                                    setSelectedStorageType(item?.StorageTypeID)
                                                    setStorageName(item?.Name)
                                                    getStorageFormData(customerString, siteString, interfaceSubTypeString, interfaceNameString, 1, totalString, false, item?.RecordingStoragePathID)
                                                    setActiveTabKey("StorageForm_Details")
                                                    setSelectedStorage(item)
                                                    setIsFormEdit(true)
                                                    setSelectedRecordingType(item?.RecordingTypeID)
                                                    setStoreRecording(item?.RecordingRetentionPeriod)
                                                    setFromTimeModal(item?.FromDateTime)
                                                    setToTimeModal(item?.ToDateTime)
                                                    setPrimaryStorageAccessURLError('')
                                                    setStorageNameError('')
                                                    setSelectedStorageTypeError('')
                                                    setStoreRecordingError('')
                                                    setSelectedRecordTypeError('')
                                                    setPrimaryStoragePathError('')
                                                    let timeBase = recordingTypeList?.find(i => i.RecordingType == "Time Based")
                                                    let scheduleBase = recordingTypeList?.find(i => i.RecordingType == "Scheduled")
                                                    console.log("selectedOption", timeBase)
                                                    console.log("selectedOption", scheduleBase)
                                                    if (item?.RecordingTypeID == timeBase?.RecordingTypeId || item?.RecordingTypeID == scheduleBase?.RecordingTypeId) {
                                                        setShowButton(true)
                                                        //isFormEdit(false)
                                                    }else{
                                                       setShowButton(false) 
                                                    }
                                                    setFromTimeError('')
                                                    setToTimeError('')
                                                    setFromTimeModalError('')
                                                    setToTimeModalError('')
                                                    //clearStorageForm()
                                                    //clearFilterList()
                                                }}
                                            >
                                                <p className="ListofText">
                                                    {item?.Name}
                                                </p>
                                            </div>
                                        </div>
                                    ))
                                    :
                                    <div className="no-data-found"><p>No Storage Name Found</p></div>
                            )
                        }
                        {
                            !storageList && (
                                <div className="no-data-found">No Storage Name Available</div>
                            )
                        }
                    </div>
                </div>

                <div className='SiteRightContainer StorageFormDiv'>
                    <Tabs defaultActiveKey="StorageForm_Details" id="uncontrolled-tab-example" className="AlertTemplateTab" activeKey={activeTabKey}
                        onSelect={(e) => { setActiveTabKey(e) }}
                    >
                        <Tab eventKey="StorageForm_Details" title="Storage Details">
                            <>
                                <div className='StorageFormScroll'>
                                    <div className="inputMainContainer w40dot75rem">
                                        <div className="inputTypeLabelContainer">
                                            <label className='formFieldLabels'>Storage Name</label>
                                            <input
                                                className="inputType"
                                                placeholder="Enter storage server here e.g.:Storage One*"
                                                value={storageName}
                                                disabled={isFormEdit}
                                                onChange={(e) => {
                                                    setStorageName(e.target.value)
                                                    setStorageNameError("")
                                                }}
                                            />
                                            <p className="Error_P" style={{ float: "left" }}><span>{storageNameError}</span></p>
                                        </div>
                                    </div>

                                    <div className="inputMainContainer w40dot75rem mt35">
                                        <div className="inputTypeLabelContainer">
                                            <label className='formFieldLabels'>Storage Type</label>
                                            <select
                                                className="inputType ArrowSelectClass"
                                                value={selectedStorageType}
                                                disabled={isFormEdit}
                                                onChange={(e) => {
                                                    setSelectedStorageType(e.target.value)
                                                    setSelectedStorageTypeError('')
                                                    //setStorageType('')
                                                }}
                                            >
                                                <option key="0" disabled={false} value="0" id="0">Select Storage Type*</option>
                                                {/* <option>Storage Type 1</option>
                                        <option>Storage Type 1</option>
                                        <option>Storage Type 1</option> */}
                                                {/* <option>Storage Type 1</option> */}

                                                {storageType &&
                                                    storageType.map((val) => (
                                                        <option value={val.StorageTypeID} key={val.StorageTypeID} id={val.StorageTypeID}>
                                                            {val.StorageType}
                                                        </option>
                                                    ))}

                                            </select>
                                            <p className="Error_P" style={{ float: "left" }}><span>{selectedStorageTypeError}</span></p>
                                        </div>
                                    </div>

                                    <div className="inputMainContainer w40dot75rem mt35">
                                        <div className="inputTypeLabelContainer">
                                            <label className='formFieldLabels'>Server Address</label>
                                            <input
                                                className="inputType"
                                                placeholder="Enter primary Address* e.g. http://192.168.0.36/2020Media/TestRecordingFolder1"
                                                disabled={true}
                                                value={item?.PrimaryServerAdd}
                                            />
                                            <p className="Error_P" style={{ float: "left" }}><span></span></p>
                                        </div>
                                    </div>

                                    {/* <div className="inputMainContainer w40dot75rem mt35">
                                <div className="inputTypeLabelContainer">
                                    <label className='formFieldLabels'>Secondary Server Address</label>
                                    <input 
                                    className="inputType"
                                    placeholder="Secondary Address* e.g. 192.168.0.54"
                                    disabled={true}
                                    //value={site?.Address}
                                    />
                                    <p className="Error_P" style={{ float: "left" }}><span></span></p>
                                </div>
                            </div> */}

                                    <div className="inputMainContainer w40dot75rem mt35">
                                        <div className="inputTypeLabelContainer">
                                            <label className='formFieldLabels'>Server Path</label>
                                            <input
                                                className="inputType"
                                                placeholder="Enter fully qualified path e.g.C://NVRCameraRecording*"
                                                value={primaryStoragePath}
                                                disabled={isFormEdit}
                                                onChange={(e) => {
                                                    setPrimaryStoragePath(e.target.value)
                                                    setPrimaryStoragePathError("")
                                                }}
                                            />

                                            <p className="Error_P" style={{ float: "left" }}><span>{primaryStoragePathError}</span></p>
                                        </div>
                                    </div>

                                    {/* <div className="inputMainContainer w40dot75rem mt35">
                                <div className="inputTypeLabelContainer">
                                    <label className='formFieldLabels'>Secondary Server Path</label>
                                    <input 
                                    className="inputType"
                                    placeholder="Secondary Server Path"
                                    value={secondaryServerPath}
                                    disabled={isFormEdit}
                                    onChange={(e) => {
                                        setSecondaryServerPath(e.target.value)
                                        setSecondaryServerPathError("")
                  }}
                                    />
                                    
                                    <p className="Error_P" style={{ float: "left" }}><span>{secondaryServerPathError}</span></p>
                                </div>
                            </div> */}

                                    <div className="inputMainContainer w40dot75rem mt35">
                                        <div className="inputTypeLabelContainer">
                                            <label className='formFieldLabels'>Server Access URL</label>
                                            <input
                                                className="inputType"
                                                placeholder="URL access recording e.g.https://192.160.0.50:8080/RecordingFoler*"
                                                value={primaryStorageAccessURL}
                                                disabled={isFormEdit}
                                                onChange={(e) => {
                                                    setPrimaryStorageAccessURL(e.target.value)
                                                    setPrimaryStorageAccessURLError("")
                                                }}
                                            />
                                            <p className="Error_P" style={{ float: "left" }}><span>{primaryStorageAccessURLError}</span></p>
                                        </div>
                                    </div>


                                    {
                                        recordingServerType?.find(i => i.RecordingServerType == "Real Time")?.RecordingServerTypeID == selectedRecordingServerType

                                            ?
                                            <div className="inputMainContainer w40dot75rem mt35">
                                                <div style={{ display: "flex" }}>
                                                    <div className="inputTypeLabelContainer" style={{ width: "100%" }}>
                                                        <label className='formFieldLabels'>Recording Type*</label>
                                                        <select className="inputType ArrowSelectClass"
                                                            value={selectedRecordingType}
                                                            disabled={isFormEdit}
                                                            onChange={handleChangeRecordingType}
                                                        // onClick={(e) => {
                                                        //     console.log('selectedOption', e.target.value);
                                                        //     let value = e.target.value
                                                        //     if (!isFormEdit && selectedRecordingType !== '') {
                                                        //         let timeBase = recordingTypeList?.find(i => i.RecordingType == "Time Based")
                                                        //         // let scheduleBase = recordingTypeList?.find(i => i.RecordingType == "Scheduled")
                                                        //         if (value == timeBase?.RecordingTypeId) {
                                                        //            setShow(true);
                                                        //         }
                                                        //     }
                                                        // }}
                                                        //                                                     onClick={() => {
                                                        //     if (!isFormEdit && selectedRecordingType == 'Time Based') {
                                                        //         setShow(true);
                                                        //     }
                                                        // }}
                                                        >
                                                            <option key="0" value="0">Select Recording Type</option>
                                                            {
                                                                recordingTypeList &&
                                                                recordingTypeList
                                                                    .filter(i => i.RecordingType != "Scheduled")
                                                                    .map((val) => (
                                                                        <option value={val.RecordingTypeId} key={val.RecordingTypeId} id={val.RecordingTypeId}>
                                                                            {val.RecordingType}
                                                                        </option>
                                                                    ))
                                                            }

                                                        </select>
                                                        <p className="Error_P" style={{ float: "left" }}><span>{selectedRecordTypeError}</span></p>

                                                        {
                                                            recordingTypeList?.find(i => i.RecordingType == "Time Based")?.RecordingTypeId == selectedRecordingType &&
                                                           
                                                            <>
                                                             <p className='m-0' style={{ textAlign: 'left' }}>From-{fromTimeModal} To-{toTimeModal}</p>
                                                            <p className="Error_P" style={{ float: "left" }}><span>{fromTimeError}</span>  <span>{toTimeError}</span></p>
                                                            
                                                             {/* <p className="Error_P" style={{ float: "left" }}><span>{toTimeError}</span></p> */}
                                                            </>
                                                        }
                                                    </div>
                                                     {
                                                        showButton
                                                            ?
                                                            <OverlayTrigger
                                                                placement='bottom'
                                                                overlay={
                                                                    <Tooltip>
                                                                        Update Time
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <button className="addCustomer" style={{ marginLeft: "10px" }} disabled={isFormEdit} onClick={(e) => {
                                                                    e.preventDefault()
                                                                    resetTime()

                                                                }}>
                                                                    <span className="ViewUpdate">
                                                                        {/* <img src={AddNode} alt="add plus icon" /> */}
                                                                        <RestoreIcon style={{ color: "#fff" }} />
                                                                    </span>
                                                                </button>
                                                            </OverlayTrigger>
                                                            :
                                                            null

                                                    }
                                                </div>
                                            
                                                   
                                            </div>
                                            :
                                            <div className="inputMainContainer w40dot75rem mt35">
                                                <div style={{ display: "flex" }}>
                                                    <div className="inputTypeLabelContainer" style={{ width: "100%" }}>
                                                        <label className='formFieldLabels'>Recording Type*</label>
                                                        <select className="inputType ArrowSelectClass"
                                                            value={selectedRecordingType}
                                                            disabled={isFormEdit}
                                                            onChange={handleChangeRecordingType}
                                                        // onClick={(e) => {
                                                        //     console.log('selectedOption', e.target.value);
                                                        //     let value = e.target.value
                                                        //     if (!isFormEdit && selectedRecordingType !== '') {
                                                        //         // let timeBase = recordingTypeList?.find(i => i.RecordingType == "Time Based")
                                                        //         let scheduleBase = recordingTypeList?.find(i => i.RecordingType == "Scheduled")
                                                        //         if (value == scheduleBase?.RecordingTypeId) {
                                                        //            setShow(true);
                                                        //         }
                                                        //     }
                                                        // }}
                                                        >
                                                            <option key="0" value="0">Select Recording Type</option>
                                                            {
                                                                recordingTypeList &&
                                                                recordingTypeList
                                                                    .filter(i => i.RecordingType === "Scheduled")
                                                                    .map((val) => (
                                                                        <option value={val.RecordingTypeId} key={val.RecordingTypeId} id={val.RecordingTypeId}>
                                                                            {val.RecordingType}
                                                                        </option>
                                                                    ))
                                                            }

                                                        </select>


                                                        <p className="Error_P" style={{ float: "left" }}><span>{selectedRecordTypeError}</span></p>

                                                        {
                                                            recordingTypeList?.find(i => i.RecordingType == "Scheduled")?.RecordingTypeId == selectedRecordingType &&
                                                            <>
                                                            <p className='m-0' style={{ textAlign: 'left' }}>From-{fromTimeModal}</p>
                                                            
                                                            <p className="Error_P" style={{ float: "left" }}><span>{fromTimeError}</span></p>
                                                            </>
                                                            
                                                            
                                                        }
                                                    </div>
                                                    {
                                                        showButton
                                                            ?
                                                            <OverlayTrigger
                                                                placement='bottom'
                                                                overlay={
                                                                    <Tooltip>
                                                                        Update Time
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <button className="addCustomer" style={{ marginLeft: "10px" }} disabled={isFormEdit} onClick={(e) => {
                                                                    e.preventDefault()
                                                                    resetTime()
                                                                }}>
                                                                    <span className="ViewUpdate">
                                                                        {/* <img src={AddNode} alt="add plus icon" /> */}
                                                                        <RestoreIcon style={{ color: "#fff" }} />
                                                                    </span>
                                                                </button>
                                                            </OverlayTrigger>
                                                            :
                                                            null

                                                    }
                                                </div>
                                            </div>
                                    }

                                    {
                                        recordingServerType?.find(i => i.RecordingServerType == "Real Time")?.RecordingServerTypeID == selectedRecordingServerType

                                            ?
                                            <Modal size="lg" show={show} onHide={() => setShow(false)} dialogClassName="modal-50w" backdrop="static" className="AddCustomerModal">
                                                <>
                                                    <Modal.Header >
                                                        <Modal.Title id="example-custom-modal-styling-title">
                                                            <p>Please select from time and to time for recording</p>
                                                        </Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>
                                                        <div style={{ display: "flex" }}>
                                                            <div className="inputMainContainer w40dot75rem mr-1">
                                                                <div className="inputTypeLabelContainer">
                                                                    <label className='formFieldLabels'>From Time</label>
                                                                    <input
                                                                        type="time"
                                                                        step={2}
                                                                        className="inputType"
                                                                        placeholder="Ex. 09:00:00 AM"
                                                                        value={fromTimeModal}
                                                                        onChange={(e) => {
                                                                            setFromTimeModal(e.target.value)
                                                                            setFromTimeModalError('')
                                                                            setFromTimeError('')
                                                                        }}
                                                                    />
                                                                    <p className="Error_P" style={{ float: "left" }}><span>{fromTimeModalError}</span></p>
                                                                </div>
                                                            </div>

                                                            <div className="inputMainContainer w40dot75rem ml-1">
                                                                <div className="inputTypeLabelContainer">
                                                                    <label className='formFieldLabels'>To Time</label>
                                                                    <input
                                                                        type="time"
                                                                        step={2}
                                                                        className="inputType"
                                                                        placeholder="Ex. 09:00:00 PM"
                                                                        value={toTimeModal}
                                                                        onChange={(e) => {
                                                                            setToTimeModal(e.target.value)
                                                                            setToTimeModalError('')
                                                                            setToTimeError('')
                                                                        }}
                                                                    />
                                                                    <p className="Error_P" style={{ float: "left" }}><span>{toTimeModalError}</span></p>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div style={{ textAlign: "center" }}>
                                                            <button className="DataAccessEdit mt-3" style={{ width: "220px" }} onClick={onSetModal}>
                                                                <span className="ViewUpdate">Set</span>
                                                            </button>
                                                            <button className="DataAccessEdit mt-3" style={{ width: "220px" }} onClick={hideModel}>
                                                                <span className="ViewUpdate">Cancel</span>
                                                            </button>
                                                        </div>
                                                    </Modal.Body>
                                                </>
                                            </Modal>
                                            :
                                            <Modal size="lg" show={show} onHide={() => setShow(false)} dialogClassName="modal-50w" backdrop="static" className="AddCustomerModal">
                                                <>
                                                    <Modal.Header >
                                                        <Modal.Title id="example-custom-modal-styling-title">
                                                            <p>Please select from time for recording</p>
                                                        </Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>
                                                        <div style={{ display: "flex" }}>
                                                            <div className="inputMainContainer w40dot75rem mr-1">
                                                                <div className="inputTypeLabelContainer">
                                                                    <label className='formFieldLabels'>From Time</label>
                                                                    <input
                                                                        type="time"
                                                                        step={2}
                                                                        className="inputType"
                                                                        placeholder="Ex. 09:00:00 AM"
                                                                        value={fromTimeModal}
                                                                        onChange={(e) => {
                                                                            setFromTimeModal(e.target.value)
                                                                            setFromTimeModalError('')
                                                                            setFromTimeError('')
                                                                        }}
                                                                    />
                                                                    <p className="Error_P" style={{ float: "left" }}><span>{fromTimeModalError}</span></p>
                                                                    
                                                                </div>
                                                                <p className="Error_P" style={{ float: "left", marginTop:"1rem", fontSize:"15px"}}><span>Note:- Backup starts at the scheduled time today and captures the previous day's 24-hour video backup only. It runs until completion and repeats daily.End time can’t be set as interruptions may skip data.</span></p>
                                                            </div>

                                                        </div>
                                                        <div style={{ textAlign: "center",marginTop:"4.5rem" }}>
                                                            <button className="DataAccessEdit mt-3" style={{ width: "220px" }} onClick={onSetModal}>
                                                                <span className="ViewUpdate">Set</span>
                                                            </button>
                                                            <button className="DataAccessEdit mt-3" style={{ width: "220px" }} onClick={hideModel}>
                                                                <span className="ViewUpdate">Cancel</span>
                                                            </button>
                                                        </div>
                                                    </Modal.Body>
                                                </>
                                            </Modal>
                                    }


                                    <div className="inputMainContainer w40dot75rem mt35">
                                        <div className="inputTypeLabelContainer">
                                            <label className='formFieldLabels'>No. of Days of Recording*</label>
                                            <input className="inputType"
                                                type='number'
                                                placeholder="Number of days e.g.1*"
                                                style={{ fontSize: "14px" }}
                                                value={storeRecording}
                                                // disabled={!isEdit && DeviceRecordingConfigID != 0}
                                                disabled={isFormEdit}
                                                onChange={(e) => {
                                                    setStoreRecording(e.target.value)
                                                    setStoreRecordingError('')

                                                }}
                                            />
                                            <p className="Error_P" style={{ float: "left" }}><span>{storeRecordingError}</span></p>
                                        </div>
                                    </div>
                                    {/* <div className="inputMainContainer w40dot75rem mt35">
                                <div className="inputTypeLabelContainer">
                                    <label className='formFieldLabels'>Secondary Server Access URL</label>
                                    <input 
                                    className="inputType"
                                    placeholder="Secondary Server Access URL"
                                    value={secondaryServerAccessURL}
                                    disabled={isFormEdit}
                                    onChange={(e) => {
                                        setSecondaryServerAccessURL(e.target.value)
                                        setSecondaryServerAccessURLError("")
                  }}
                                    />
                                    <p className="Error_P" style={{ float: "left" }}><span>{secondaryServerAccessURLError}</span></p>
                                </div>
                            </div> */}
                                </div>
                                <div style={{ textAlign: "center", marginBottom: "10px" }}>
                                    {
                                        isFormEdit
                                        &&
                                        <button className="DataAccessEdit" style={{ width: "100px" }} onClick={clearStorageForm}>
                                            <span className="ViewUpdate">Add New</span>
                                        </button>
                                    }
                                    {
                                        isFormEdit
                                        &&
                                        <button className="DataAccessEdit" style={{ width: "100px" }} onClick={() => setIsFormEdit(false)}>
                                            <span className="ViewUpdate">Edit</span>
                                        </button>
                                    }
                                    {
                                        !isFormEdit
                                        &&
                                        <button className="DataAccessEdit" style={{ width: "100px" }} onClick={onSaveStoargeForm}>
                                            <span className="ViewUpdate">Save</span>
                                        </button>
                                    }
                                    {
                                        isFormEdit
                                        &&
                                        <button className="DataAccessEdit" style={{ width: "100px" }}
                                            onClick={deleteStorageForm}
                                        >
                                            <span className="ViewUpdate">Delete</span>
                                        </button>
                                    }
                                </div>
                            </>
                        </Tab>
                        <Tab eventKey="StorageForm_Table" title="Storage Device Table" disabled={(selectedStorage == null)}
                            selectedStorage={selectedStorage}
                        >
                            <>
                                <div className="FilteredCameraListDiv">
                                    <div
                                        className={selectedFilterName == "" ? "SavedFilterDiv" : "SavedFilterDiv dropdownSelectionContainer"}
                                    >
                                        {/* <Dropdown>
                    <Dropdown.Toggle variant="light">
                      {
                        selectedFilterName != ""
                          ? `Saved Filter: ${selectedFilterName}`
                          : "Saved Filter"
                      }
                    </Dropdown.Toggle>
                    {
                      selectedFilterName != ""
                        ?
                        <button className="SavedFilterCancelBtn" onClick={() => {
                          if (selectedFilterName != "") {
                            //clearSelectedFilter()
                          }
                        }}><img src={FilterClearIcon} alt="Clear" /></button>

                        : null
                    }
                    <Dropdown.Menu>
                      <>
                        {
                          filterList.length > 0
                            ?
                            filterList.map((item) => (
                              <Dropdown.Item className='p-0'>
                                <div className="SavedFilterOption" onClick={() => {
                                  setSelectedFilterName(item.FilterName)
                                  setSelectedFilter(item.FilterId)
                                 setDeviceSelected([]);
                                setZoneSelected([]);
                                //   setAlertTypeSelected([]);
                                  setSiteSelected([]);
                                  setCustomerSelected([]);
                                  setDisableSaveBtn(false);
                                  setFilterApplied(false);
                                }}>
                                  <span>{item.FilterName}</span>
                                  <div className="SaveFilterOtionHover">
                                    <button style={{ background: "transparent" }} onClick={(e) => {
                                      e.stopPropagation();
                                    //   setOpenDeleteFilter(true)
                                    //   setModalFilterName(item.FilterName)
                                    //   setModalFilterId(item.FilterId)
                                    }}><img alt="Delete" src={DeleteIcon} /></button>
                                    <button style={{ background: "transparent" }} onClick={(e) => {
                                      //infoFilterList(item.FilterId)
                                      e.stopPropagation();
                                      //setOpenInfoFilter(true)
                                      //setModalFilterName(item.FilterName)
                                      //setModalFilterId(item.FilterId)
                                    }}><img alt="Info" src={InfoIcon1} /></button>
                                  </div>
                                </div>
                              </Dropdown.Item>
                            ))
                            :
                            <Dropdown.Item style={{ cursor: 'default' }}>
                              <span>No Saved Filters.</span>
                            </Dropdown.Item>
                        }
                      </>
                    </Dropdown.Menu>
                  </Dropdown> */}
                                    </div>
                                    {/* <MultiSelect
                                options={options}
                                value={selected}
                                onChange={setSelected}
                                labelledBy="Saved Filter"
                            /> */}
                                    {/* <h4>OR</h4> */}
                                    <FilterToolDDLTemp {...filterToolDDLProps} />
                                    {/* <MultiSelect
                                options={options}
                                value={selected}
                                onChange={setSelected}
                                labelledBy="Customer"
                            />

                            <MultiSelect
                                options={options}
                                value={selected}
                                onChange={setSelected}
                                labelledBy="Site"
                            />

                            <MultiSelect
                                options={options}
                                value={selected}
                                onChange={setSelected}
                                labelledBy="Device"
                            />

                            <MultiSelect
                                options={options}
                                value={selected}
                                onChange={setSelected}
                                labelledBy="Zone"
                            /> */}

                                    <OverlayTrigger
                                        placement="bottom"
                                        overlay={<Tooltip>Apply Filter</Tooltip>}
                                    >
                                        <button
                                            className={disableSaveBtn ? "IconsButtonDiv" : "buttonDisable"}
                                            disabled={!disableSaveBtn} onClick={applyFilterOnClick}
                                            name="filterBtn"
                                        >
                                            <img
                                                src={FilterIcon}
                                                className="camera-icon-height"
                                                alt="Save filter icon"
                                            />
                                        </button>
                                    </OverlayTrigger>
                                    <OverlayTrigger
                                        placement="bottom"
                                        overlay={<Tooltip>Clear Filter</Tooltip>}
                                    >
                                        <button
                                            className={disableSaveBtn ? "IconsButtonDiv" : "buttonDisable"}
                                            onClick={clearFilterList}
                                            disabled={!disableSaveBtn}
                                            name="clearFilterBtn"
                                        >
                                            <img
                                                src={ClearFilter}
                                                className="camera-icon-height"
                                                alt="Save filter icon"
                                            />
                                        </button>
                                    </OverlayTrigger>
                                </div>
                                <div>
                                    <div className="card-body p-0">
                                        <div className="SampleTableDiv">
                                            <div className="table-container">
                                                <table className="responsive-table">
                                                    <thead>
                                                        <tr>
                                                            {/* <th>
                                                               <input type='checkbox' style={{marginLeft:"5px"}}/> 
                                                            </th> */}

                                                            <th className='TextButtonHeader' style={{ width: "13%" }}>
                                                                <p>Add/Remove To Selected Storage</p>
                                                            </th>
                                                            <th className='TextButtonHeader' style={{ width: "12%" }}>
                                                                <p>Recording</p>
                                                                <select required className="ArrowSelect HMTableSelect"
                                                                    value={selectEnableRecording}
                                                                    onChange={(e) => {
                                                                        setSelectEnableRecording(e.target.value)
                                                                    }}
                                                                >
                                                                    <option key="0" disabled={false} value="">
                                                                        - Select -
                                                                    </option>
                                                                    <option value="all">All</option>
                                                                    <option value="true">Enable</option>
                                                                    <option value="false">Disable</option>
                                                                </select>
                                                            </th>
                                                            <th className='TextButtonHeader' style={{ width: "12%" }}>
                                                                <p>Device ID</p>
                                                                <div className="SearchTextDiv StatusSearchText">
                                                                    <input
                                                                        className="SearchViewInput"
                                                                        type="text"
                                                                        placeholder="Search"
                                                                        value={deviceIdSearch}
                                                                        onChange={(e) => setDeviceIdSearch(e.target.value)}
                                                                    />
                                                                    {
                                                                        isDarkTheme ?
                                                                            <img
                                                                                className="EyeIcon"
                                                                                alt="Search-icon"
                                                                                src={SearchIcon}
                                                                                onClick={() => searchListDetails()}
                                                                            /> :
                                                                            <img
                                                                                className="EyeIcon"
                                                                                alt="Search-icon"
                                                                                src={SearchIconWhite} height="15"
                                                                                onClick={() => searchListDetails()}
                                                                            />
                                                                    }
                                                                </div>
                                                            </th>

                                                            <th className='TextButtonHeader'>
                                                                <p>Device Name</p>
                                                                <div className="SearchTextDiv StatusSearchText">
                                                                    <input
                                                                        className="SearchViewInput"
                                                                        type="text"
                                                                        placeholder="Search"
                                                                        value={deviceNameSearch}
                                                                        onChange={(e) => setDeviceNameSearch(e.target.value)}
                                                                    />
                                                                    {
                                                                        isDarkTheme ?
                                                                            <img
                                                                                className="EyeIcon"
                                                                                alt="Search-icon"
                                                                                src={SearchIcon}
                                                                                onClick={() => searchListDetails()}
                                                                            /> :
                                                                            <img
                                                                                className="EyeIcon"
                                                                                alt="Search-icon"
                                                                                src={SearchIconWhite} height="15"
                                                                                onClick={() => searchListDetails()}
                                                                            />
                                                                    }
                                                                </div>
                                                            </th>

                                                            {/* <th>
                                                <p>Actions</p>
                                                </th>

                                                <th>
                                                <p>Add/Remove To Recording</p>
                                                </th> */}



                                                            {/* <th>
                                                                <p style={{ width: "250px" }}>Input Source URL</p>
                                                                <div className="SearchTextDiv StatusSearchText">
                                                                    <input
                                                                        className="SearchViewInput"
                                                                        type="text"
                                                                        placeholder="Search"
                                                                        value={inputUrlSearch}
                                                                        onChange={(e) => setInputUrlSearch(e.target.value)}
                                                                    />
                                                                    {
                                                                        isDarkTheme ?
                                                                            <img
                                                                                className="EyeIcon"
                                                                                alt="Search-icon"
                                                                                src={SearchIcon}
                                                                                onClick={() => searchListDetails()}
                                                                            /> :
                                                                            <img
                                                                                className="EyeIcon"
                                                                                alt="Search-icon"
                                                                                src={SearchIconWhite} height="15"
                                                                                onClick={() => searchListDetails()}
                                                                            />
                                                                    }
                                                                </div>
                                                            </th> */}

                                                            {/* <th>
                                                                <p>Store Recordings<br />(Days)*</p>
                                                            </th> */}

                                                            {/* <th>
                                                <p>Recording Length (HH:MM:SS)*</p>
                                                </th> */}

                                                            {/* <th>
                                                        <p style={{width:"100px"}}>Encoding</p>
                                                        <select required className="ArrowSelect HMTableSelect"
                                                            value={selectEncoding}
                                                            onChange={(e) => {
                                                                setSelectEncoding(e.target.value)
                                                            }}
                                                        >
                                                            <option key="0" disabled={false} value="">
                                                                - Select -
                                                            </option>
                                                            <option value="all">All</option>
                                                            <option value="true">Enable</option>
                                                            <option value="false">Disable</option>
                                                        </select>
                                                    </th> */}

                                                            {/* <th>
                                                <p style={{width:"100px"}}>Transcoding</p>
                                                </th>

                                                <th>
                                                <p style={{width:"100px"}}>FPS</p>
                                                </th> */}

                                                            {/* <th>
                                                                <p style={{ width: "180px" }}>Recording Type*</p>
                                                                <div className="SearchTextDiv StatusSearchText">
                                                                    <input
                                                                        className="SearchViewInput"
                                                                        type="search"
                                                                        placeholder="Search"
                                                                        value={recordingTypeSearch}
                                                                        onChange={(e) => setRecordingTypeSearch(e.target.value)}
                                                                    />
                                                                    {
                                                                        isDarkTheme ?
                                                                            <img
                                                                                className="EyeIcon"
                                                                                alt="Search-icon"
                                                                                src={SearchIcon}
                                                                                onClick={() => searchListDetails()}
                                                                            /> :
                                                                            <img
                                                                                className="EyeIcon"
                                                                                alt="Search-icon"
                                                                                src={SearchIconWhite} height="15"
                                                                                onClick={() => searchListDetails()}
                                                                            />
                                                                    }
                                                                </div>
                                                            </th> */}



                                                            {/* <th>
                                                                <p>Actions</p>
                                                            </th> */}

                                                        </tr>
                                                    </thead>

                                                    <tbody style={{ border: "1px solid #d4d4d4" }}
                                                    >
                                                        {
                                                            filterList && filterList.length > 0 ?
                                                                (
                                                                    filterList.map((val) => (
                                                                        <StorageConfigItem
                                                                            data={val} transcodingList={transcodingList} selectedStorage={selectedStorage} key={val?.DeviceID}
                                                                            count={count} setCount={setCount} recordingTypeList={recordingTypeList} RecordingServerTypeID={item?.RecordingServerTypeID} recordingServerType={recordingServerType}
                                                                            fromTimeModal={fromTimeModal}
                                                                            toTimeModal={toTimeModal}
                                                                            storeRecording={storeRecording}
                                                                            selectedRecordingType={selectedRecordingType}
                                                                        />
                                                                    ))
                                                                )
                                                                :
                                                                (
                                                                    <div class="no-report-found"><p className='noRecordFoundText'>No Record Available</p></div>
                                                                )
                                                        }











                                                        {/* <tr>
                                                <td style={{minWidth:"80px", width:"4%"}}>
                                                    <input type='checkbox' />
                                                </td>
                                                <td>1</td>
                                                <td>HikVision NVR_1-201	</td>
                                                
                                                <td>
                                                    <div className='togglecheckbox'>                                                                           
                                                        <label>
                                                            <input
                                                                type="checkbox"
                                                            />
                                                            <span />
                                                        </label>
                                                    </div> 
                                                </td>
                                                <td>
                                                    <div className={'inputTypeLabelContainer'}>
                                                        <input className="inputType"
                                                        placeholder="Enter stream address here"
                                                        style={{fontSize:"14px"}}
                                                        />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className={'inputTypeLabelContainer'}>
                                                        <input className="inputType"
                                                        type='number'
                                                        placeholder="Number of days"
                                                        style={{fontSize:"14px"}}
                                                        />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className={'inputTypeLabelContainer'}>
                                                        <input className="inputType"
                                                        type='time'
                                                        step={2}
                                                        style={{fontSize:"14px"}}
                                                        />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='togglecheckbox'>                                                                           
                                                        <label>
                                                            <input
                                                                type="checkbox"
                                                            />
                                                            <span />
                                                        </label>
                                                    </div> 
                                                </td>
                                                <td>
                                                    <div className={'inputTypeLabelContainer'}>
                                                        <select className="inputType ArrowSelectClass">
                                                            <option key="0" disabled={false} value="0" id="0">Select</option>
                                                            <option>Select 1</option>
                                                            <option>Select 1</option>
                                                            <option>Select 1</option>
                                                        </select>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className={'inputTypeLabelContainer'}>
                                                        <select className="inputType ArrowSelectClass">
                                                            <option key="0" disabled={false} value="0" id="0">Select</option>
                                                            <option>Select 1</option>
                                                            <option>Select 1</option>
                                                            <option>Select 1</option>
                                                        </select>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className={'inputTypeLabelContainer'}>
                                                        <select className="inputType ArrowSelectClass" onChange={handleChange}>
                                                            <option key="0" value="0">Select</option>
                                                            <option value="Schedule">Schedule</option>
                                                            <option value="Continuous">Continuous</option>
                                                            <option value="Event base">Event base</option>
                                                        </select>
                                                        <p className='m-0'>From-10.00 To-3.00</p>
                                                    </div>
                                                </td>
                                                  <td>
                                                    <button className="DataAccessEdit" disabled style={{width:"65px"}}>
                                                        <span className="ViewUpdate">Edit</span>
                                                    </button>
                                                    <button className="DataAccessEdit" disabled style={{width:"65px"}}>
                                                        <span className="ViewUpdate">Update</span>
                                                    </button>
                                                    <button className="DataAccessEdit" disabled style={{width:"65px"}}>
                                                        <span className="ViewUpdate">Reset</span>
                                                    </button>
                                                    <button className="DataAccessEdit" disabled style={{width:"65px"}}>
                                                        <span className="ViewUpdate">Cancel</span>
                                                    </button>
                                                </td>
                                                <td>
                                                    <button className="DataAccessEdit" disabled style={{width:"65px"}}>
                                                        <span className="ViewUpdate">Add</span>
                                                    </button>
                                                </td>
                                            </tr> */}
                                                    </tbody>
                                                </table>
                                            </div>

                                            {
                                                totalPages === 0 || totalPages <= limit
                                                    ? null
                                                    : <div className="PaginationDiv mb-2 mt-2 mr-2">
                                                        <h5 className='PageNumbers'>
                                                            {
                                                                totalPages == 0 ? 0
                                                                    :
                                                                    (currentPageNo - 1) * parseInt(limit) + parseInt(1)} - {(currentPageNo * limit) > (totalPages)
                                                                        ? (totalPages)
                                                                        : currentPageNo * limit}
                                                        </h5>
                                                        <span>of</span>
                                                        <h5 className="PageNumbers">{totalPages}</h5>
                                                        <Pagination>
                                                            <Pagination.Prev onClick={prevClick} disabled={currentPageNo == 1} />
                                                            {
                                                                PaginationComponentOne(currentPageNo)
                                                            }
                                                            <Pagination.Next onClick={nextClick} disabled={currentPageNo == maxPageAllowed} />
                                                        </Pagination>
                                                    </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </>
                        </Tab>
                    </Tabs>


                    {/* <Modal size="lg" show={show} onHide={() => setShow(false)} dialogClassName="modal-50w" backdrop="static" className="AddCustomerModal">
                    <>
                        <Modal.Header >
                            <Modal.Title id="example-custom-modal-styling-title">
                                Camera name comes here
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                        <div style={{display:"flex"}}>
                            <div className="inputMainContainer w40dot75rem mr-1">
                                <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>From Time</label>
                                    <input
                                    type="time"
                                    step={2}
                                    className="inputType"
                                    placeholder="Ex. 09:00:00 AM" />
                                    <p className="Error_P" style={{ float: "left" }}><span></span></p>
                                </div>
                            </div>

                            <div className="inputMainContainer w40dot75rem ml-1">
                                <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>To Time</label>
                                    <input
                                    type="time"
                                    step={2}
                                    className="inputType"
                                    placeholder="Ex. 09:00:00 PM" />
                                    <p className="Error_P" style={{ float: "left" }}><span></span></p>
                                </div>
                            </div>
                        </div>
                        <div style={{textAlign: "center"}}>
                            <button className="DataAccessEdit mt-3" style={{ width: "220px" }}>
                                <span className="ViewUpdate">Save</span>
                            </button>
                            <button className="DataAccessEdit mt-3" style={{ width: "220px" }} onClick={hideModel}>
                                <span className="ViewUpdate">Cancel</span>
                            </button>
                        </div>
                        </Modal.Body>
                    </>
                    </Modal> */}

                </div>
            </div>
        </div>
    )
}

export default StorageConfig